import React from "react";
const Footer = () => {
  return (
    <footer className="app-footer text-center text-muted">
      <span className="text-center">
        <small>
          Developed by
          <a
            href="http://www.algorisys.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Algorisys Technolgies Pvt. Ltd
          </a>
          <span> &copy; {new Date().getFullYear()}</span>
        </small>
      </span>
    </footer>
  );
};
export default Footer;
